var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-stepper-step',{staticClass:"stepper-step",attrs:{"step":_vm.step,"editable":_vm.editable,"complete":_vm.complete,"color":_vm.complete ? 'success' : 'primary',"complete-icon":_vm.icons.yes,"edit-icon":_vm.complete ? _vm.icons.yes : _vm.icons.edit}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }